import React, { useState, useEffect } from 'react'
import Landing from "../../assets/landing.jpg"
import conceirge from "../../assets/icons/concr.png"
import chef from '../../assets/icons/chef.png'
import vaccum from '../../assets/icons/vaccum.png'
import award from '../../assets/icons/award.png'
import Modal from '../../components/common/Modal'
import Host from '../../assets/host.jpg'
import family from '../../assets/family.jpg'
import { useNavigate } from "react-router-dom";
import manager from '../../assets/manager.png'
import { useGetAllApartmentsQuery } from '../../store/api/apartment'
import raheja from '../../assets/apartments/victoria.jpg'

function Home() {

    const staticApartment = {
        id: 'static-1',
        name: "Raheja Vista",
        location: "Coming soon",
        address: { city: "Coming soon" },
        price: "0",
        images: [{ image: raheja, sequence: "1" }]
    };

    const { data: ApartmentsData } = useGetAllApartmentsQuery()
    const [results, setResults] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    // console.log(results, "123");

    const baseUrl = process.env.REACT_APP_API_URL?.replace("/api", "") || '';

    useEffect(() => {
        if (ApartmentsData && Array.isArray(ApartmentsData)) {
            setResults(ApartmentsData)
        }
    }, [ApartmentsData])

    const getImageUrl = (path) => {
        if (!path) return '';
        if (path.startsWith('http')) return path;
        return `${baseUrl}${path}`;
    };

    const handleImageError = (e) => {
        e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
    }

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };



    const hasData = results && results.length > 0;

    return (
        <>
            <section className="bg-[#F5F3F1] ">
                <div
                    className="min-h-[60vh] sm:min-h-[60vh] md:min-h-[100vh] bg-cover bg-center relative"
                    style={{ backgroundImage: `url(${Landing})` }}
                >
                    <div
                        className="absolute inset-0 flex flex-col items-center justify-center text-center px-4
                                   md:bg-[linear-gradient(to_right,rgba(255,255,255,0.7)_0%,rgba(255,255,255,0)_60%)]"
                    >
                        <h1
                            className="font-thin  text-xl md:text-[40px] text-[#181D24] animate-slide-up"
                            style={{
                                textShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)',
                                animation: 'slideUp 2s ease-out forwards'
                            }}
                        >
                            A TAILOR MADE STAY
                        </h1>
                    </div>
                </div>
            </section>

            <style jsx global>{`
                @keyframes slideUp {
                    from {
                        transform: translateY(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
            `}</style>

            <section>
                <main className="">
                    <section className="py-16 px-4 bg-[#F5E9D6]">
                        <div className="max-w-7xl mx-auto">
                            <div className="text-center mb-12">
                                <h2 className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 font-['Rufina]" >
                                    Your Apartments
                                </h2>
                                {/* <h2 className="hidden md:block text-4xl lg:text-5xl font-semibold text-[#181D24] mb-6" style={{ fontFamily: "Rufina" }}>
                                    Your Apartments
                                </h2> */}
                                <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
                                    Stunningly maintained apartments equipped with all your essentials and more. Your own private concierge & chauffeur, keeping you comfortable and stress free both in and outside of your apartment.
                                </p>
                            </div>

                            {hasData ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

                                    {results.map((apartment) => (
                                        <ApiApartmentCard
                                            key={apartment.id}
                                            apartment={apartment}
                                            getImageUrl={getImageUrl}
                                            onNavigate={() => navigate("/apartments", {
                                                state: {
                                                    name: apartment.name,
                                                    apartmentId: apartment.id
                                                }
                                            })}
                                        />
                                    ))}


                                    <StaticApartmentCard
                                        apartment={staticApartment}

                                    />
                                </div>
                            ) : (

                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                                    <StaticApartmentCard
                                        apartment={staticApartment}

                                    />
                                </div>
                            )}
                        </div>
                    </section>
                </main>
            </section>

            <section>
                <div className="bg-gradient-to-b from-[#F5F3F1] to-[#F5E9D6] 
                md:from-[#F5F3F1] md:to-[#F5F3F1]">


                    <div className="text-center py-10">
                        <h2
                            className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 font-['Rufina]"
                            style={{ fontFamily: "Rufina" }}
                        >
                            Your Comforts
                        </h2>

                        <div className="flex flex-col md:flex-row md:items-stretch md:justify-center max-w-6xl mx-auto">
                            {[
                                {
                                    icon: conceirge,
                                    title: "Concierge Manager",
                                    subtitle: "Know more",
                                    onClick: handleOpenModal,
                                },
                                {
                                    icon: award,
                                    title: "Luxury Apartments",
                                    subtitle: "Know more",
                                    onClick: () => navigate("/apartments")
                                },
                                {
                                    icon: vaccum,
                                    title: "Chauffeur Service",
                                    subtitle: "charge your car",
                                    onClick: () => navigate("/chauffeur")
                                },
                                {
                                    icon: chef,
                                    title: "Personalized F&B",
                                    subtitle: "work out",
                                    onClick: () => navigate("/#")
                                },
                            ].map((item, index) => (
                                <div
                                    key={index}
                                    onClick={item.onClick}
                                    className={`
          group cursor-pointer 
          flex flex-col items-center justify-center 
          py-8 px-4 md:px-6
          ${index < 3 ? 'border-b md:border-b-0 md:border-r' : ''}
          border-[#C9BDAB]
          hover:bg-white/50
          transition-all duration-300
          w-full md:w-auto
          flex-1
        `}
                                >
                                    <div className="flex flex-col items-center gap-4 transform transition-transform duration-300 group-hover:scale-105">
                                        <div className="p-3 rounded-full bg-white/80 shadow-sm">
                                            <img
                                                src={item.icon}
                                                alt={item.title}
                                                className="h-8 w-8 md:h-10 md:w-10 opacity-80"
                                            />
                                        </div>

                                        <div className="text-center">
                                            <h3 className="font-semibold text-[#181d24] text-lg md:text-xl font-serif mb-2">
                                                {item.title}
                                            </h3>
                                            <p className="text-sm md:text-base text-[#7e7e7e] flex items-center justify-center gap-1">
                                                {item.subtitle}
                                                <span className="ml-1 transition-transform duration-300 group-hover:translate-x-1">→</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <section className=" py-8 px-4">
                        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-8 ">
                            <div className="w-full md:w-[45%] px-2 md:px-8 order-1 ">
                                {/* <h2 className="text-3xl font-semibold text-[#181D24] mb-6 md:hidden text-center" style={{ fontFamily: "Rufina" }}>
                                    Your Host,
                                </h2> */}
                                <h2 className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 font-['Rufina]" style={{ fontFamily: "Rufina" }}>
                                    Your Host,
                                </h2>

                                <div className="space-y-4 text-[#181D24]">
                                    <p className="text-sm md:text-base" style={{ fontFamily: "Raleway", fontWeight: "500" }}>
                                        Firstly, thank you for visiting our page, India holds a very special place in my heart and with that the
                                        culture and tranquility the city offers is something that kept drawing me back to her and eventually
                                        starting a family and settling.
                                    </p>

                                    <p className="text-sm md:text-base" style={{ fontFamily: "Raleway", fontWeight: "500" }}>
                                        I've spent the better part of the last thirty years watching our city grow expediently. If you visited ten
                                        years ago, you'd be overwhelmed with this grown-up 2025 version.
                                    </p>

                                    <p className="text-sm md:text-base" style={{ fontFamily: "Raleway", fontWeight: "500" }}>
                                        It's important you get the most out of your trip when staying with us. Personally, I enjoy my comfort and
                                        convenience and this in essence is what our hospitality is all about
                                    </p>

                                    <p className="text-sm md:text-base" style={{ fontFamily: "Raleway", fontWeight: "500" }}>
                                        We have a driver to take you around and our concierge on the phone for any questions or assistance you may
                                        need. Our tailored F&B services are designed to give you that diet your used too or require if you are
                                        coming for medical reasons.
                                    </p>

                                    <p className="text-sm md:text-base mt-6" style={{ fontFamily: "Raleway", fontWeight: "500" }}>
                                        In short, "the final details" are really  the DNA behind our services and offerings, indeed our apartments are well sort after,rest assured when you stay with us you're a proper guest. What I need you to feel when you head home from an enjoyable stay, is happiness.
                                    </p>

                                    <p className="text-sm md:text-base" style={{ fontFamily: "Raleway", fontWeight: "500" }}>
                                        I look forward to welcoming you during your visit. My Team and I are here to ensure your stay with us is just
                                        right!
                                    </p>

                                    <p className="text-base md:text-lg mt-6 font-semibold" style={{ fontFamily: "Raleway" }}>
                                        Alexander Johnson
                                    </p>
                                </div>


                            </div>
                            <div className="w-full md:w-[55%] relative flex justify-center  order-2 mb-10">
                                <div className="relative  max-w-md ">
                                    <img
                                        src={family}
                                        alt="Alexander Johnson"
                                        className="w-[400px] max-w-xs md:max-w-full ml-[44px] sm:ml-32  md:ml-16  rounded-tr-[40px] md:rounded-tr-[50px] mx-auto  px-0 md:px-0  mb-6 "
                                    />
                                    <img
                                        src={Host}
                                        alt="Group of friends"
                                        className="absolute -bottom-6 md:-left-36 -left-5 md:-bottom-3 md:-right-6  max-w-[500px] md:h-[300px] md:w-[250px] w-[200px]  rounded-bl-[25px] md:rounded-bl-[40px] border-4 md:border-8 border-[#F5F3F1]  "
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                    <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
                        <img
                            src={manager}
                            alt="Concierge Manager"
                            className="w-full h-48 object-cover object-center rounded-lg mb-4 mt-4"
                        />
                        <h2 className="text-lg font-bold mb-2 text-[#000000] font-[Raleway]">Concierge Manager</h2>
                        <p className="text-[#181D24] text-sm mb-2 font-[Rufina] ">
                            My name is Ian Langley, and I serve as the Property Manager at AJP
                            Hospitality, based in Pune, Maharashtra. Originally from the UK, I've
                            spent the past 19 years living and working in India embracing its rich
                            cultural diversity and vibrant cuisine alongside my wife over the last
                            17 years.
                        </p>
                        <p className="text-[#181D24] text-sm  font-[Rufina]">
                            I'm delighted to introduce you to our business. Please feel free to
                            reach out to me if you need any support.
                        </p>
                    </Modal>
                </div>

            </section>
        </>
    )
}

function ApiApartmentCard({ apartment, getImageUrl, onNavigate }) {
    const [index, setIndex] = useState(0);
    const images = apartment.images || [];
    useEffect(() => {
        if (images.length <= 1) return;

        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [images.length]);

    const handleImageError = (e) => {
        e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
    };

    return (
        <div
            onClick={onNavigate}
            className="relative group overflow-hidden rounded-br-[40px] rounded-tl-[40px] shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer bg-white"
        >
            <div className="aspect-[4/3] relative overflow-hidden">
                {images.length > 0 ? (
                    <>
                        <div
                            className="flex h-full transition-transform duration-700 ease-in-out"
                            style={{ transform: `translateX(-${index * 100}%)` }}
                        >
                            {images.map((img, i) => (
                                <img
                                    key={i}
                                    src={getImageUrl(img.image)}
                                    alt={`${apartment.name} - Image ${img.sequence}`}
                                    className="w-full h-full object-cover flex-shrink-0"
                                    onError={handleImageError}
                                />
                            ))}
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                        {images.length > 1 && (
                            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
                                {images.map((_, i) => (
                                    <div
                                        key={i}
                                        className={`w-2 h-2 rounded-full transition-all ${index === i ? "bg-white" : "bg-white/40"
                                            }`}
                                    />
                                ))}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="w-full h-full bg-gray-300 flex items-center justify-center">
                        <span className="text-gray-500">No images</span>
                    </div>
                )}
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="text-lg font-semibold mb-1 text-balance line-clamp-1">
                    {apartment.name}
                </h3>
                <div className="flex items-center text-gray-200 text-sm mb-1">
                    <svg className="w-4 h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-pretty text-sm line-clamp-1">
                        {apartment.address?.city || 'Location not specified'}
                    </span>
                </div>

                <div className="flex justify-between items-center mt-1">
                    <div className="text-right">
                        <span className="text-xl font-semibold">
                            ₹{parseInt(apartment.price || 0).toLocaleString('en-IN')}
                        </span>
                        {/* <div className="text-xs text-gray-300">per night</div> */}
                    </div>
                </div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center 
        bg-black/40 opacity-0 group-hover:opacity-100 
        transition-opacity duration-300">
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onNavigate();
                    }}
                    className="px-6 py-2 bg-white text-black font-semibold rounded-full shadow-lg 
            hover:bg-gray-200 transition-all"
                >
                    Book Now
                </button>
            </div>
        </div>
    );
}

function StaticApartmentCard({ apartment, onNavigate }) {
    const [index, setIndex] = useState(0);
    const images = apartment.images || [];

    const handleImageError = (e) => {
        e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
    };

    return (
        <div
            onClick={onNavigate}
            className="relative group overflow-hidden rounded-br-[40px] rounded-tl-[40px] shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer bg-white"
        >
            <div className="aspect-[4/3] relative overflow-hidden">
                {images.length > 0 ? (
                    <>
                        <img
                            src={images[0].image}
                            alt={apartment.name}
                            className="w-full h-full object-cover"
                            onError={handleImageError}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                        <div className="absolute top-4 right-4 bg-yellow-500 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg">
                            Coming Soon
                        </div>
                        <div
                            className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="bg-white backdrop-blur-3xl  rounded-br-[20px] rounded-tl-[20px] px-4 py-4 text-center pointer-events-none">
                                <span className="text-gray-900 font-semibold text-lg">Stay Tuned</span>
                                <p className="text-gray-700 text-sm mt-1">Updates coming soon</p>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="w-full h-full bg-gray-300 flex items-center justify-center">
                        <span className="text-gray-500">No images</span>
                    </div>
                )}
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="text-lg font-semibold mb-1 text-balance line-clamp-1">
                    {apartment.name}
                </h3>
                <div className="flex justify-between items-center mt-1">
                    <div className="text-right">
                        <span className="text-sm text-gray-300 italic">Launching Soon</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home